import { FC, ReactNode } from 'react';

export interface TabProps {
    header: ReactNode;
    children: ReactNode;
}

const Tab: FC<TabProps> = () => <></>;

export default Tab;
